import React from 'react';

import { applicationSettings } from '~/shared/application.settings';
import { Dropdown } from '~/shared/components';
import { normalizeLocale, persistLanguage } from '~/shared/language-storage';
import { changeLocale, IntlContextConsumer } from 'gatsby-plugin-intl';

import intlConfig from '../../../intl.config';

const { localeTitles } = intlConfig;

/**
 * Persists the user's choice (localStorage + cookie shared with the Nuxt app)
 * synchronously, before gatsby-plugin-intl starts its SPA navigation —
 * onRouteUpdate covers this as well, but the cookie must be written upfront
 * so the main app picks it up even if navigation is interrupted.
 *
 * @param {string} locale - Selected locale code (e.g. "en")
 */
const handleChangeLocale = (locale) => {
  persistLanguage(normalizeLocale(locale) || locale);
  changeLocale(locale);
};

export const LanguageSwitcher = React.memo(() => (
  <IntlContextConsumer>
    {({ languages, language: currentLocale }) => {
      if (languages.length === 1 || applicationSettings.ENABLE_LANG_SWITCHER !== 'true') return <></>;
      return (
        <Dropdown
          options={languages
            .filter((language) => language !== currentLocale)
            .map((language) => ({ title: localeTitles[language] || language, value: language }))}
          active={currentLocale}
          onChange={handleChangeLocale}
        />
      );
    }}
  </IntlContextConsumer>
));
